define('lib/Podio.UI.Form',['require','underscore','lib/Podio.UI','lib/Podio.Event.UI'],function(require) {

  var _ = require('underscore');
  var podioUI = require('lib/Podio.UI');
  var eventUI = require('lib/Podio.Event.UI');

  function onAddFieldButtonClick(elmTarget, e) {
    var elmWrapper =  elmTarget.parent();
    var elmLastInput = elmWrapper.find('input:visible:last');
    if(elmLastInput.is(':blank')) {
      elmLastInput.focus();
      return;
    }

    var elmClonedInput = elmLastInput.clone();
    elmClonedInput.val('').removeAttr('id').removeClass('error valid');
    elmClonedInput.insertBefore(elmTarget);
    elmClonedInput.focus();


    elmWrapper.height(elmWrapper.height());
    _.defer(function() {elmWrapper.height('auto'); });
  }

  function onFormKeyPress(elmTarget, e) {
    if (e.keyCode === 13 && e.ctrlKey) {
      e.preventDefault();
      elmTarget.submit();
    }
  }

  function onFormDisableOnSubmit(elmTarget, e) {
    var elmSubmitButton = elmTarget.find('input[type=submit]');
    podioUI.disableButtonWithLoader(elmSubmitButton);
  }

  eventUI.bind('click', '.form-add-field-button', onAddFieldButtonClick);
  eventUI.bind('keypress', 'form', onFormKeyPress, true);
  eventUI.bind('submit', 'form[data-disable-on-submit]', onFormDisableOnSubmit, true);

});

